import { AutocompleteInput, ReferenceInput, TextInput, required } from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Модел"
          source="model"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Производител"
          source="manufacturer"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Сериен номер"
          source="serialNumber"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Инвентарен номер"
          source="inventoryNumber"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <TextInput
          label="Описание"
          source="description"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <ReferenceInput
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
        >
          <AutocompleteInput
            label="Катедра"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
